import React, { useEffect, useState } from 'react';
import MiddGPTLogo from '../../assets/icons/CampusLLMLogoSmall.png';

/**
 * Welcome screen component displayed when no conversation is in progress
 * @param {Object} props
 * @param {boolean} props.isOnPhone - Whether the user is on a phone device
 * @returns {JSX.Element} The welcome screen component
 */
const WelcomeScreen = ({ isOnPhone }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    setIsVisible(true);
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center h-3/4 text-center space-y-4"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out'
      }}
    >
      <img src={MiddGPTLogo} className="w-16 h-16" alt="MiddGPT Logo"/>
      <h1 className="text-2xl font-semibold dark:text-white">Welcome to CampusLM</h1>
      <p className="text-gray-600 dark:text-gray-300 max-w-md">
        Your AI assistant for navigating Middlebury College resources, events, and information.
      </p>
    </div>
  );
};

export default WelcomeScreen;